// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/compare/compare.css
// module id = 1533
// module chunks = 0